import React, { Component } from 'react'
import NumberFormat from 'react-number-format';
import ls from 'local-storage'

import Cart from '../components/Cart'

class Products extends Component {
    static getDerivedStateFromProps(nextProps, prevState){
        console.log('Products derived');
        if( nextProps.match.params.id !== prevState.id ){
            console.log('Products state upd');
            return {
                data: {},
                id: nextProps.match.params.id
            };
        }
        return null;
    }
    constructor(props) {
        super(props);
        this.state = {id:null, data:{}, cart:{id: null, total:0, products:[]}};
    }
    componentDidMount () {
        console.log('Products mount');
        this.load(this.state.id);
        this.setStateCartByLocalStorage();
    }
    componentDidUpdate(prevProps, prevState){
        console.log('Products update');
        if( this.state.id!==prevState.id){
            this.load(this.state.id);
            this.setStateCartByLocalStorage();
        }
    }
    load(id){
        console.log('Products load');
        let api = process.env.REACT_APP_API_URL+'/get-products/id/'+id+'?key=' + process.env.REACT_APP_API_KEY;
        fetch(api).then((response) => response.json()).then((responseJson) => {
            console.log(responseJson);
            if( !responseJson.data ){
                this.setState({id:id, data: {}});
            } else {
                this.setState({id:id, data: responseJson.data});
            }
        });
    }
    setLocalStorage(){
        ls.set('cart', this.state.cart);
    }
    clearLocalStorage(){
        ls.clear();
    }
    setStateCartByLocalStorage(){
        let cart = ls.get('cart');
        if( !cart || this.state.id != cart.id ){
            cart = {id: null, total:0, products:[]};
        }
        this.setState({cart: cart});
    }
    addCart(product){
        //console.log(product);
        document.getElementById("cart-content").scrollIntoView(true);
        let cart = this.state.cart;
        for (let v of cart.products) {
            if( v.id==product.id ){
                //既にその商品が入っている場合は何もしない
                return null;
            }
        }
        product.num = 1;
        cart.products.push(product);
        this.setState({cart: cart});
        this.calcTotal();
    }
    removeCart(product){
        if( window.confirm('買い物かごから削除してよろしいですか？') ){
            let cart = this.state.cart;
            cart.products = cart.products.filter(v => v.id !== product.id);
            this.setState({cart: cart});
            this.calcTotal();
        }
    }
    addProductNum(product, add){
        let cart = this.state.cart;
        for (let i in cart.products) {
            if( cart.products[i].id==product.id ){
                cart.products[i].num += add;
                if(cart.products[i].num==0){
                    this.removeCart(product);
                    return;
                } else {
                    this.setState({cart: cart});
                    this.calcTotal();
                    return;
                }
            }
        }
    }
    calcTotal(){
        let cart = this.state.cart;
        let total = 0;
        for (let v of cart.products) {
            total += v.num * v.price;
        }
        cart.total = total;
        cart.id = this.state.id;
        this.setState({cart: cart});
        this.setLocalStorage();
    }
    renderProducts(){
        if( Object.keys(this.state.data).length==0 ){
            return null;
        }
        let products = [];
        for(let v of this.state.data) {
            products.push(
                <div key={v.id} className="col-lg-3 col-md-4 col-6">
                    <div className="item-product">
                        <div className={"note-item-product "+(v.want_flg? '': 'd-none')}>
                            <span className="text-note-item-product">
                                特に欲しいもの
                            </span>
                        </div>
                        <div className="text-center background-image-naka" style={{"backgroundImage": "url("+v.image_url+")"}}></div>
                        <div className="content-item-product">
                            <div className="name-item-product">
                                {v.name}
                            </div>
                            <div className="description-item-product">
                                {v.main_list_comment}
                            </div>
                        </div>
                        <div className="price-item-product">
                            販売価格（税込）
                            <span><NumberFormat value={v.price} displayType={'text'} thousandSeparator={true}/>円</span>
                        </div>
                        <div className="text-center">
                            <a className="btn btn-buy" onClick={()=>this.addCart(v)}>
                                <div className="btn-cart-naka">
                                    <img src="/images/icon-cart.png" className="img-fluid"/>
                                    <span>商品をかごに入れる</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div className="row">
                {products}
            </div>
        );
    }
    render() {
        return (
            <div>
                <div className="list-product">
                    <div className="container">
                        <div className="icon-list-product">
                            <img src="/images/icon_04.png"/>
                        </div>
                        <div className="title-list-product">
                            商品を選ぶ
                        </div>
                        {this.renderProducts()}
                    </div>
                </div>
                <Cart cart={this.state.cart} addProductNum={(product,add)=>this.addProductNum(product,add)} removeCart={(product)=>this.removeCart(product)}/>
            </div>
        )
    }
}

export default Products